/**
 * Generates OData filter query for user search
 */
export const generateUserSearchQuery = (searchText: string): string => {
  if (!searchText) return "";

  const searchLower = searchText.toLowerCase();
  return `(contains(firstname,'${searchLower}') or contains(lastname,'${searchLower}') or contains(internalemailaddress,'${searchLower}') or contains(domainname,'${searchLower}'))`;
};

/**
 * Generates OData filter query for region
 */
export const generateRegionFilterQuery = (region: number): string => {
  if (!region) return "";
  return `dogma_region eq ${region}`;
};

/**
 * Generates OData filter query for team
 */
export const generateTeamFilterQuery = (team: number): string => {
  if (!team) return "";
  return `dogma_team eq ${team}`;
};

/**
 * Combines multiple filter queries with 'and' operator
 */
export const combineFilterQueries = (queries: string[]): string => {
  const validQueries = queries.filter((q) => q && q.trim() !== "");
  return validQueries.join(" and ");
};

/**
 * Generates OData filter query for role
 */
export const generateRoleFilterQuery = (roleId: string): string => {
  if (!roleId) return "";
  return `dogma_AppRole_SystemUser_SystemUser/any(r:r/dogma_approleid eq '${roleId}')`;
};

/**
 * Generates OData filter query for user status (1=Active, 2=Deactivated)
 */
export const generateStatusFilterQuery = (status: number): string => {
  if (!status) return "";
  return `dogma_userstatus eq ${status}`;
};